module.exports = __webpack_public_path__ + "static/board-07-a2e13060dcda964fbc84a1e45feebb30.jpg";